import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { Tool } from '@services/tools';

export abstract class JournalTool extends Tool {
  abstract isEnabledFor(callcard: CallCard): boolean;
}
